import PartnerRufaLogo from './PartnerRufaLogo';

export default PartnerRufaLogo;
